import { BindingError } from "../BindingError.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var _a;
class BijectiveIndexedMap {
  constructor(inverseOrMap) {
    __publicField(this, "valueStore");
    __publicField(this, "index");
    __publicField(this, "indexSeed");
    __publicField(this, "inverse");
    __publicField(this, _a, "BijectiveIndexedMap");
    if (inverseOrMap instanceof BijectiveIndexedMap) {
      this.valueStore = new Map(inverseOrMap.valueStore);
      this.index = new Map(inverseOrMap.index);
      this.indexSeed = inverseOrMap.indexSeed;
      this.inverse = inverseOrMap.inverse;
    } else {
      this.valueStore = /* @__PURE__ */ new Map();
      this.index = /* @__PURE__ */ new Map();
      this.indexSeed = 0;
      this.inverse = inverseOrMap;
    }
  }
  getNewIndex() {
    return this.indexSeed++;
  }
  get size() {
    return this.valueStore.size;
  }
  clear() {
    this.valueStore.clear();
    this.index.clear();
  }
  delete(key) {
    const index = this.index.get(key);
    if (index === void 0) {
      return false;
    }
    this.valueStore.delete(index);
    this.index.delete(key);
    return true;
  }
  forEach(callback, thisArg) {
    for (const [key, value] of this.entries()) {
      callback.call(thisArg, value, key, this);
    }
  }
  get(key) {
    const index = this.index.get(key);
    if (index === void 0) {
      return void 0;
    }
    return this.valueStore.get(index);
  }
  has(key) {
    return this.index.has(key);
  }
  set(key, value) {
    const existingIndex = this.index.get(key);
    if (existingIndex === void 0) {
      const newIndex = this.getNewIndex();
      this.index.set(key, newIndex);
      this.valueStore.set(newIndex, value);
    } else {
      this.valueStore.set(existingIndex, value);
    }
    return this;
  }
  changeKey(oldKey, newKey) {
    const index = this.index.get(oldKey);
    if (index === void 0) {
      throw new BindingError();
    }
    this.index.delete(oldKey);
    this.index.set(newKey, index);
    return this;
  }
  changeKeyOrder(newOrder) {
    for (const key of newOrder) {
      const keyIndex = this.index.get(key);
      if (keyIndex === void 0) {
        throw new BindingError();
      }
      const value = this.valueStore.get(keyIndex);
      this.valueStore.delete(keyIndex);
      this.valueStore.set(keyIndex, value);
    }
  }
  *[(_a = Symbol.toStringTag, Symbol.iterator)]() {
    yield* this.entries();
  }
  *entries() {
    for (const value of this.values()) {
      yield [this.inverse(value), value];
    }
  }
  *keys() {
    for (const value of this.values()) {
      yield this.inverse(value);
    }
  }
  *values() {
    for (const value of this.valueStore.values()) {
      if (value === void 0) {
        continue;
      }
      yield value;
    }
  }
}
export {
  BijectiveIndexedMap
};
//# sourceMappingURL=BijectiveIndexedMap.js.map
